import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Controller, useFormContext } from "react-hook-form";
import { InputErrorMessage } from "~/components/Form/InputErrorMessage";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const TableWrapper = styled.div`
    border: 1px solid ${(p) => (p.isInvalid ? p.theme.colors.red : "transparent")};

    table.table {
        margin-bottom: 0;
    }
`;
const TableDataCell = styled.td`
    background-color: ${(p) => (p.disabled ? "#c8ccd0" : "")};
    text-align: center;
    position: relative;

    > .data-cell-caption {
        position: absolute;
        bottom: 0;
        right: 0.15rem;
        user-select: none;
        font-size: 0.55rem;
        color: ${(p) => p.theme.colors.secondary};
    }
`;

const TableField = ({ onChange = (_value) => {}, value, field, selectIcon = faCheck, isInvalid }) => {
    const { t } = useTranslation("common");

    const selectCell = (ri, ci) =>
        onChange(
            value?.map((val, i) => (i === ri ? val.map((val, i) => (i === ci ? !val : val)) : val)) ||
                field.rows.map(() => field.columns.map(() => false))
        );

    const getArr = (arr, ri, ci) =>
        arr && Array.isArray(arr) && arr.length >= ri && Array.isArray(arr[ri]) && arr[ri].length >= ci && arr[ri][ci];

    return (
        <TableWrapper isInvalid={isInvalid} className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        {field.columns.map((col) => (
                            <th key={col} scope="col">
                                {t(col)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {field.rows.map((row, ri) => (
                        <tr key={ri}>
                            <th scope="row">{row}</th>
                            {field.columns.map((col, ci) => (
                                <TableDataCell
                                    key={ci}
                                    disabled={getArr(field.disabledTimes, ri, ci)}
                                    onClick={() => (!getArr(field.disabledTimes, ri, ci) ? selectCell(ri, ci) : null)}
                                >
                                    {!getArr(field.disabledTimes) && getArr(value, ri, ci) ? (
                                        <FontAwesomeIcon icon={selectIcon} />
                                    ) : (
                                        ""
                                    )}
                                    <span className="data-cell-caption">{t(col).substring(0, 2) + " - " + row}</span>
                                </TableDataCell>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </TableWrapper>
    );
};

const ControlledTableField = ({ field, className, label, name, ...props }) => {
    const { control } = useFormContext();

    return (
        <div className={"form-group" + (className ? " " + className : "")} {...props}>
            {label && <label>{label}</label>}
            <Controller
                control={control}
                name={name || field.name}
                defaultValue={field.rows.map(() => field.columns.map(() => false))}
                render={({ field: { onChange, value }, fieldState: { invalid } }) => (
                    <TableField isInvalid={invalid} field={field} value={value} onChange={onChange} {...props} />
                )}
            />
            <InputErrorMessage name={name || field.name} />
        </div>
    );
};

export { TableField };

export default ControlledTableField;
